(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessories-faq"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  /*$("#accessories-faq .faqs-wrapper .faqs-items .faqs-item .item-right .item-content").click(function(){
    var that = $(this);
    if (that.hasClass("active")) {
      that.removeClass("active");
    } else {
      that.addClass("active");
    }
  });*/
});

  } catch(e) { console.error(e); }
})();
})();
